import React from 'react';

const DateCell = React.createClass({

	propTypes : {
		'date' : React.PropTypes.string.isRequired // date in yyyy-mm-dd
	},
	render : function(){

		var d = this.props.date.substr(8,2) + '-' + this.props.date.substr(5,2) + '-' + this.props.date.substr(0,4);
		return (
			<span>{d}</span>
		)
	}

});

export default DateCell;


// WEBPACK FOOTER //
// ./shared/DateCell.jsx